<template>
  <!-- 日志列表 -->
  <div class="">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <yq-date-range v-model:start-time="searchInfo.startTime" v-model:end-time="searchInfo.endTime" >
            <template #prefix>搜索时间</template>
          </yq-date-range>
          <el-input v-model="searchInfo.searchKey" placeholder="请输入查询关键字" @keydown.enter="resetSearch">
            <template #prefix>关键字</template>
          </el-input>
        </template>
        <template #option>
          <page-button hasPerm="log:query" ref="toSearchData" type="read" el-type="primary" @click="resetSearch">查询</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border >
          <yq-table-column  label="操作人员" prop="createdName"/>
          <yq-table-column label="操作时间" prop="createdTime"/>
          <yq-table-column label="操作内容" prop="accessName"/>
          <yq-table-column label="ip地址" prop="ipAddress"/>
          <yq-table-column label="操作地点" prop="address">
            <template v-slot="{row}">
              {{row.ipGeoAddress }}
            </template>
          </yq-table-column>
          <yq-table-column  label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button type="write" @click="toShowDetail(row)">查看</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
    <el-dialog dialog-width="2" title="操作日志明细" v-model="showDetail">
      <dialog-table>
        <form-items label-width="2.4rem" icon-width="0" :columns="2">
          <form-item label="操作人员">{{currentData.createdName}}</form-item>
          <form-item label="操作时间">{{currentData.createdTime}}</form-item>
          <form-item label="登录ip">{{currentData.ipAddress}} / {{currentData.ipGeoAddress}}</form-item>
          <form-item label="请求方式">{{ currentData.requestMethod }}</form-item>
          <form-item :show-block="true" label="请求参数" align-items="flex-start">
            {{currentData.accessArgs}}
          </form-item>
        </form-items>
      </dialog-table>
      <div slot="footer">
        <page-button @click="showDetail = false" el-type="primary">确认</page-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition";
import FormPage from "@/components/h5/layout/FormPage";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage";
import TableButton from "@/components/h5/button/TableButton";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import systemLogsApi from "@/api/normal/sys/systemLogsApi";
import YqDateRange from "@/components/h5/date/YqDateRange.vue";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "SystemLogs",
  components: {
    DialogTable, FormItem, FormItems, PageButton, YqDateRange,
    YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage
  },
  data() {
    return {
      searchInfo: {},
      dataList: [
      ],
      showDetail: false,
      currentData: {},
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    if (!Util.loadPageData(this)) { // 加载缓存数据失败，初始化页面
      this.$nextTick().then(() => {
        // 开始时间和结束时间，默认查询一周内的数据
        this.searchInfo.endTime = new Date().format("yyyy-MM-dd") + " 23:59:59";
        // 今天是周几
        let day = new Date().getDay();
        if (day === 0) {
          day = 7;
        }
        // 获取周一
        this.searchInfo.startTime = new Date(new Date().getTime() - (day - 1) * 24 * 3600 * 1000).format("yyyy-MM-dd") + " 00:00:00";
        this.$refs.toSearchData.clickEvent();
      })
    }
  },
  methods: {
    queryList() {
      systemLogsApi.queryList(this.searchInfo).then(res => {
        let list = res.records;
        for (let i = 0; i < list.length; i++) {
          this.geoIpAddress(list[i]);
        }
        this.dataList = list;
        this.searchInfo.totalCount = res.totalCount;
      })
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    toShowDetail(data) {
      systemLogsApi.findById(data.id).then(res => {
        this.geoIpAddress(res);
        this.currentData = res;
        this.showDetail = true;
      })
    },
    // 更新实际地址
    geoIpAddress(data) {
      // 实际地址
      data.ipGeoAddress = data.ipAddress !== '' && (data.ipAddress.startsWith("192.168") || data.ipAddress.startsWith("172.") || data.ipAddress.startsWith("10."))? '本地内网': data.ipGeoAddress;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>